"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _externalAuthContext = require("./externalAuthContext");
Object.keys(_externalAuthContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _externalAuthContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _externalAuthContext[key];
    }
  });
});
